import { Resolver, Query, FieldResolver, Root, Args, Arg, Ctx } from 'type-graphql'
import { Domain, getQueryBuilderFromListParams, getRepository, ListParam } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'
import { UserPreference } from './user-preference'
import { UserPreferenceList } from './user-preference-type'

@Resolver(UserPreference)
export class UserPreferenceQuery {
  @Query(returns => UserPreference!, { nullable: true, description: 'To fetch a UserPreference' })
  async preference(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<UserPreference> {
    const { domain } = context.state

    return await getRepository(UserPreference).findOne({
      where: { domain: { id: domain.id }, id }
    })
  }

  @Query(returns => UserPreference, { nullable: true, description: `To fetch a User's own UserPreference` })
  async myUserPreference(
    @Arg('key') key: string,
    @Arg('element') element: string,
    @Ctx() context: any
  ): Promise<UserPreference> {
    const { domain, user } = context.state

    return await getRepository(UserPreference).findOne({
      where: { domain: { id: domain.id }, user: { id: user.id }, key }
    })
  }

  @Query(returns => UserPreferenceList, { description: 'To fetch multiple UserPreferences' })
  async myUserPreferences(
    @Args(type => ListParam) params: ListParam,
    @Ctx() context: ResolverContext
  ): Promise<UserPreferenceList> {
    const { domain, user } = context.state

    const queryBuilder = getQueryBuilderFromListParams({
      domain,
      params,
      repository: await getRepository(UserPreference),
      searchables: ['key']
    }).andWhere({ user: { id: user.id } })

    const [items, total] = await queryBuilder.getManyAndCount()

    return { items, total }
  }

  @FieldResolver(type => Domain)
  async domain(@Root() preference: UserPreference): Promise<Domain> {
    return preference.domainId && (await getRepository(Domain).findOneBy({ id: preference.domainId }))
  }

  @FieldResolver(type => User)
  async updater(@Root() preference: UserPreference): Promise<User> {
    return preference.updaterId && (await getRepository(User).findOneBy({ id: preference.updaterId }))
  }

  @FieldResolver(type => User)
  async creator(@Root() preference: UserPreference): Promise<User> {
    return preference.creatorId && (await getRepository(User).findOneBy({ id: preference.creatorId }))
  }
}
